import WithRender from "../../templates/buttons/downloadPDFButton.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActivePreview"]),
    IsPreview2D: function () {
      return this.getActivePreview == "preview2D";
    }
  },
  methods: {
    ...mapActions(["packingDownloadPdf"]),

    onDownload: function () {
      this.packingDownloadPdf();
    }
  }
});
